export default __webpack_public_path__ + "static/media/logo-rectangle.781c7cb3.png";